import React, { useState, useRef } from 'react';
import { useSurveyList } from '../../../Hooks/Features/SurveyManagement/useSurveyList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MultiSelect } from 'primereact/multiselect';
import DatePicker from 'react-multi-date-picker';
import { AgGridReact } from '@ag-grid-community/react';
import PanelHeaderTemplate from '../../../components/CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate';
import { Menu } from 'primereact/menu';
import { Dialog } from 'primereact/dialog';
import CreateSurvey from '../../../components/Survey/CreateSurvey';
import { SkeletonDataTable } from '../../../components/Loader/Loader';
import _ from 'underscore';
import PreviewSurvey from '../../../components/Survey/PreviewSurvey';
import { useCommon } from '../../../Hooks/Common/useCommon';
import ShareEvaluatorSurvey from '../../../components/Survey/ShareEvaluatorSurvey';
import ShareDirectSurvey from '../../../components/Survey/ShareDirectSurvey';
import { dateConvert } from '../../../utils/Helper';
import { IconButton } from '@mui/material';

const SurveyList = () => {

    const { checkPermission } = useCommon();
    const { tagRef, filterValues, setFilterValues, getSurveyInfoList, options, showCreateSurvey, setShowCreateSurvey, columnDef, rowData, menuRef, menuItems, viewDialog, setViewDialog, handleAction, loader, onFilterTextBoxChanged, attachScrollListener, showShareSurvey, setShowShareSurvey, handleExportSurveyData } = useSurveyList();
    const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);
    const datePickerRef = useRef(null);

    return (
        <div ref={() => checkPermission("survey", tagRef)}>
            <div ref={tagRef} id='{"tabname": "survey", "data": "survey_tab"}'>
                <div className='d-flex justify-content-between align-items-center my-2 gap-3 px-3'>
                    <div className='d-flex gap-2 align-items-center flex-grow-1'>
                        <h5 className="mb-0 text-nowrap">Survey List</h5>
                        <div className='w20 ms-3' style={{ minWidth: "150px" }}>
                            <input type="text" id="filter-text-box" placeholder="Search..." onInput={(e) => onFilterTextBoxChanged(e.target.value)} value={filterValues?.search} className='w100 sk-input-dd' />
                        </div>
                    </div>
                    <div className='d-flex gap-2 justify-content-end align-items-center'>
                        <button className='sk-btn sk-btn-primary rounded' onClick={() => getSurveyInfoList()} title="Refresh"><FontAwesomeIcon icon="fa-solid fa-rotate" /></button>
                        <button className='sk-btn sk-btn-primary rounded' onClick={() => setShowFiltersDrawer(true)} title="Filters"><FontAwesomeIcon icon="fa-solid fa-filter" /></button>
                        <button className='sk-btn sk-btn-primary bg-black text-white rounded' onClick={() => setShowCreateSurvey((prev) => ({ ...prev, visible: true }))} title="Create Survey"><FontAwesomeIcon icon="fa-solid fa-plus" /></button>
                    </div>
                </div>
                <div className='mt-2'>
                    {loader?.grid ?
                        <div>
                            <SkeletonDataTable numSkeletons={20} />
                        </div> :
                        <div className='ag-theme-alpine inventory-grid' style={{ height: "calc(100vh - 100px)" }}>
                            <AgGridReact columnDefs={columnDef} rowData={rowData?.filtered} rowHeight={60} headerHeight={30} onGridReady={() => attachScrollListener()} />
                        </div>
                    }
                </div>

                <Menu className="survey-menu" model={menuItems} popup ref={menuRef} appendTo={document.body} />
                <Dialog visible={showCreateSurvey?.visible} onHide={() => { setShowCreateSurvey((prev) => ({ ...prev, visible: false, data: [], edit_survey_id: 0, edit_survey_name: "" })); getSurveyInfoList(); }} header={_.isEmpty(showCreateSurvey?.data) ? "Create Survey" : "Edit Survey"} draggable={false} className='modal-large' style={{ width: "65vw", maxWidth: "90vw" }}>
                    <CreateSurvey options={options} onClose={() => { setShowCreateSurvey((prev) => ({ ...prev, visible: false, data: [], edit_survey_id: 0, edit_survey_name: "" })); getSurveyInfoList(); }} editData={showCreateSurvey?.data} gridData={rowData?.all} />
                </Dialog>

                <Dialog visible={viewDialog?.revert || viewDialog?.delete || viewDialog?.publish || viewDialog?.excel} onHide={() => { setViewDialog((prev) => ({ ...prev, revert: false, delete: false, publish: false, excel: false, username: "", password: "", surveyData: "", showPassword: false })); setShowCreateSurvey((prev) => ({ ...prev, edit_survey_id: 0, edit_survey_name: "", data: [] })); }} header={viewDialog?.header} draggable={false} className={`${viewDialog?.excel ? "modal-xsmall" : "modal-medium"}`}>
                    <div>
                        {viewDialog?.revert ?
                            <div className='fs-6'>
                                This will un-publish the survey <span className='fw-semibold'>"{showCreateSurvey?.edit_survey_name}"</span> and return it to a draft state. Are you sure?
                            </div> : viewDialog?.delete ?
                                <div className='fs-6'>
                                    This will permanently delete the draft survey <span className='fw-semibold'>"{showCreateSurvey?.edit_survey_name}"</span>. This action cannot be undone. Are you sure?
                                </div> : viewDialog?.publish ?
                                    <div className='fs-6'>
                                        This will publish the survey <span className='fw-semibold'>"{showCreateSurvey?.edit_survey_name}"</span> and make it available for sharing and scheduling. Are you sure?
                                    </div> : <></>
                        }
                        {
                            viewDialog?.excel && <div className='px-2'>
                                <div className='my-2 input-set '>
                                    <label>Username</label>
                                    <input type='text' value={viewDialog?.username} onChange={(e) => setViewDialog((prev) => ({ ...prev, username: e.target.value }))} className=' py-2 w100 input-dd'/>
                                </div>

                                <div className="input-set my-2 mx-0">
                                    <label>Password</label>
                                    <div className="position-relative">
                                        <input
                                            value={viewDialog?.password}
                                            onChange={(e) => setViewDialog((prev) => ({ ...prev, password: e.target.value }))}
                                            type={viewDialog?.showPassword ? "text" : "password"}
                                            className="w100 input-dd"
                                            name="password"
                                            autoComplete='new-password'
                                        />
                                        <IconButton
                                            style={{ position: "absolute", top: "12px", right: "10px" }}
                                            aria-label="toggle password visibility"
                                            onClick={() => setViewDialog((prev) => ({ ...prev, showPassword: !prev?.showPassword }))}
                                        >
                                            {viewDialog?.showPassword ? (
                                                <FontAwesomeIcon icon="fa-solid fa-eye-slash" />
                                            ) : (
                                                <FontAwesomeIcon icon="fa-solid fa-eye" />
                                            )}
                                        </IconButton>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className='text-right'>
                            <button className='sk-btn sk-btn-primary' onClick={() => { setViewDialog((prev) => ({ ...prev, revert: false, delete: false, publish: false, excel: false })); setShowCreateSurvey((prev) => ({ ...prev, edit_survey_id: 0, edit_survey_name: "" })); }}>Cancel</button>
                            {(loader?.revert || loader?.delete || loader?.publish || loader?.excel) ?
                                <button className={`button btn-${viewDialog?.delete ? "danger" : "primary"}`} style={{ width: "70px" }}>
                                    <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                                        <span className="sr-only"></span>
                                    </div>
                                </button> :
                                <button className={`button rounded btn-${viewDialog?.delete ? "danger" : "primary"}`} onClick={() => {
                                    viewDialog?.excel ? handleExportSurveyData() : handleAction(viewDialog?.revert ? "revert" : viewDialog?.delete ? "delete" : "publish")
                                }}>
                                    {viewDialog?.revert ? "Revert" : viewDialog?.delete ? "Delete" : viewDialog?.excel ? "Downalod" : "Publish"}
                                </button>
                            }
                        </div>
                    </div>
                </Dialog>

                <Dialog visible={viewDialog?.duplicate} onHide={() => { setViewDialog((prev) => ({ ...prev, duplicate: false, duplicate_survey_name: "", copy_opts: {} })); setShowCreateSurvey((prev) => ({ ...prev, edit_survey_id: 0, edit_survey_name: "" })); }} header="Duplicate Survey" draggable={false} className='modal-medium'>
                    <div>
                        <div className='fs-6'>
                            Creating a copy of survey details and questions of <span className='fw-semibold'>"{showCreateSurvey?.edit_survey_name}"</span>.
                            <div>The new survey will be saved as a draft.</div>
                        </div>
                        <div className='mt-2 d-flex gap-2 align-items-center'>
                            <label className='fw-semibold'>New Name: </label>
                            <input type='text' className='input-dd w85' value={viewDialog?.duplicate_survey_name} onChange={(e) => setViewDialog((prev) => ({ ...prev, duplicate_survey_name: e?.target?.value }))} />
                        </div>
                        <div className='mt-2 d-flex gap-4 align-items-center'>
                            <div className='fw-semibold'>Also Copy:</div>
                            <div className='d-flex gap-5'>
                                {options?.survey_copy_option?.map(item => (
                                    <div className='d-flex align-items-center gap-2' key={item?.survey_copy_option_key}>
                                        <input type='checkbox' checked={viewDialog?.copy_opts?.[item?.survey_copy_option_key]} onChange={(e) => setViewDialog((prev) => ({ ...prev, copy_opts: { ...prev?.copy_opts, [item?.survey_copy_option_key]: e.target?.checked } }))} />
                                        <div>{item?.survey_copy_option_name}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className='text-right mt-2'>
                            {loader?.duplicate ?
                                <button className="sk-btn sk-btn-primary bg-black text-white" style={{ width: "90px" }}>
                                    <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                                        <span className="sr-only"></span>
                                    </div>
                                </button> :
                                <button className='sk-btn sk-btn-primary bg-black text-white' onClick={() => handleAction("duplicate")}>Create Copy</button>}
                        </div>
                    </div>
                </Dialog>

                <Dialog visible={viewDialog?.preview} onHide={() => { setViewDialog((prev) => ({ ...prev, preview: false })); setShowCreateSurvey((prev) => ({ ...prev, data: [], edit_survey_id: 0, edit_survey_name: "" })); }} header={viewDialog?.header} draggable={false} className='modal-xsmall survey-preview-dialog' style={{ width: "32vw", maxWidth: "32vw" }}>
                    <PreviewSurvey surveyData={showCreateSurvey?.data} />
                </Dialog>

                <Dialog visible={showShareSurvey} onHide={() => { setShowShareSurvey(false); setShowCreateSurvey((prev) => ({ ...prev, data: [], edit_survey_id: 0, edit_survey_name: "" })); getSurveyInfoList(); }} draggable={false} className='modal-xlarge' style={{ maxHeight: showCreateSurvey?.data?.survey_details?.[0]?.survey_type_key === "evaluator_assisted" ? "80vh" : "70vh", height: showCreateSurvey?.data?.survey_details?.[0]?.survey_type_key === "evaluator_assisted" ? "80vh" : "70vh" }}
                    header={() => {
                        return (
                            <div>Share Survey: "{showCreateSurvey?.edit_survey_name}" <span className='text-danger'>({dateConvert(showCreateSurvey?.data?.survey_details?.[0]?.start_datetime, "date-time-months")} - {dateConvert(showCreateSurvey?.data?.survey_details?.[0]?.end_datetime, "date-time-months")} )</span></div>
                        )
                    }}>
                    {showCreateSurvey?.data?.survey_details?.[0]?.survey_type_key === "evaluator_assisted" ?
                        <ShareEvaluatorSurvey surveyData={showCreateSurvey?.data} />
                        : showCreateSurvey?.data?.survey_details?.[0]?.survey_type_key === "direct_response" ?
                            <ShareDirectSurvey surveyData={showCreateSurvey?.data} />
                            : <></>
                    }
                </Dialog>

            </div>

            {/* Right Panel Filters Drawer */}
            <div className={`sk-drawer-overlay ${showFiltersDrawer ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setShowFiltersDrawer(false); }}>
                <div className={`sk-drawer-panel ${showFiltersDrawer ? 'open' : ''}`}>
                    <div className="sk-drawer-header">
                        <h5 className="sk-drawer-title">Filters</h5>
                        <div className="d-flex align-items-center gap-2">
                            <button className="sk-drawer-clear-btn" onClick={() => {
                                setFilterValues({
                                    ...filterValues,
                                    types: [],
                                    users: [],
                                    date: null,
                                    status: null,
                                    is_change: true
                                });
                            }}>Clear All</button>
                            <button className="sk-drawer-close-btn" onClick={() => setShowFiltersDrawer(false)}>
                                <FontAwesomeIcon icon="fa-solid fa-xmark" />
                            </button>
                        </div>
                    </div>
                    <div className="sk-drawer-body">
                        <div className='d-flex flex-column gap-4'>
                            {/* Status Filter */}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Status</div>
                                <div className="sk-segment-control mb-3">
                                    {options?.status?.map((item) => (
                                        <button
                                            key={item.status_id}
                                            type="button"
                                            className={`sk-segment-btn ${filterValues?.status === item.status_key ? 'active' : ''}`}
                                            onClick={() => {
                                                setFilterValues((prev) => ({
                                                    ...prev,
                                                    status: item.status_key,
                                                    is_change: true,
                                                }));
                                                getSurveyInfoList("status", item.status_key);
                                            }}
                                        >
                                            {item.status_name}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            {/* Datepicker Range Filter */}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Select Date Range</div>
                                <DatePicker
                                    ref={datePickerRef}
                                    placeholder='Select Date'
                                    range
                                    rangeHover
                                    value={filterValues?.date}
                                    onChange={(e) => {
                                            if (!e || e.length === 2) {
                                                setFilterValues((prev) => ({ ...prev, date: e, is_change: true }));
                                        if (e && e.length === 2) {
                                            datePickerRef.current?.closeCalendar();
                                        }
                                            }
                                        }}
                                    onClose={() => { if (filterValues?.is_change) getSurveyInfoList() }}
                                    style={{ width: "100%" }}
                                    containerStyle={{ width: "100%" }}
                                />
                            </div>

                            {/* Dimensions Filter */}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Types & Users</div>
                                <div className="d-flex flex-column gap-2">
                                    <MultiSelect className='sk-input-dd w-100' placeholder='Types' options={options?.types} optionLabel='survey_type_name' value={filterValues?.types} onChange={(e) => setFilterValues((prev) => ({ ...prev, types: e.target?.value, is_change: true }))} onHide={() => { if (filterValues?.is_change) { getSurveyInfoList(); } }} filter filterInputAutoFocus panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'types', filterValues.types, (val) => setFilterValues((prev) => ({ ...prev, types: val })), () => { getSurveyInfoList("type"); })} />
                                    <MultiSelect className='sk-input-dd w-100' placeholder='Users' options={options?.users} optionLabel='user_display_name' value={filterValues?.users} onChange={(e) => setFilterValues((prev) => ({ ...prev, users: e.target?.value, is_change: true }))} onHide={() => { if (filterValues?.is_change) { getSurveyInfoList(); } }} filter filterInputAutoFocus panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'users', filterValues.users, (val) => setFilterValues((prev) => ({ ...prev, users: val })), () => { getSurveyInfoList("user"); })} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sk-drawer-footer">
                        <button className="sk-btn .sk-btn-primary-filter w-100 py-2" onClick={() => {
                            getSurveyInfoList();
                            setShowFiltersDrawer(false);
                        }}>Apply Filters</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SurveyList;